import { StatsQuery } from '../../stats/types'
import { useChartTimeframePathWatch } from '../use-chart-timeframe-path-watch'

const originalElement = document.querySelector<HTMLAnchorElement>('.js-stock-detail-link a')

export default function StockDetailLink() {
  const currentTimeframePath = useChartTimeframePathWatch()
  if (!currentTimeframePath)
    return (
      <a href={originalElement?.href} className={originalElement?.className}>
        Stock Detail
      </a>
    )

  const newURL = new URL(currentTimeframePath, window.location.origin)
  newURL.searchParams.delete(StatsQuery.ChartType)

  return (
    <a href={`${newURL.pathname}${newURL.search}`} className="tab-link font-semibold">
      Stock Detail
    </a>
  )
}
